module.exports = __webpack_public_path__ + "img/pro_four_1.1b232f7c.jpg";